import React from "react";
import MLBPlayersDashboard from "../components/mlb-players/MLBPlayersDashboard";

const MLBPlayersContainer = () => <MLBPlayersDashboard />;

export default MLBPlayersContainer;
